module.exports = __webpack_public_path__ + "static/bruketa_zinic-bw-f923ed30d264faff15f652ebcd3b7d52.jpg";